(function () {
  'use strict';

  var root = document.querySelector('[data-wishlist-grid]');
  if (!root) return;

  var section = root.closest('.wishlist') || document;
  var emptyEl = section.querySelector('[data-wishlist-empty]');
  var summaryEl = section.querySelector('[data-wishlist-summary]');
  var liveEl = section.querySelector('[data-wishlist-live]');

  var strings = {};
  try {
    var raw = section.querySelector('[data-wishlist-strings]');
    if (raw) strings = JSON.parse(raw.textContent) || {};
  } catch (e) {  }

  function money(item) {
    if (item.p) return item.p;
    if (item.min > 0) return '$' + (item.min / 100).toFixed(2);
    return '';
  }

  function card(item) {
    var li = document.createElement('li');
    li.className = 'wishlist__item';

    var a = document.createElement('a');
    a.className = 'wishlist__link';
    a.href = '/products/' + encodeURIComponent(item.h);

    var media = document.createElement('span');
    media.className = 'wishlist__media';
    if (item.img) {
      var img = document.createElement('img');
      img.className = 'wishlist__img';
      img.src = item.img;
      img.alt = '';
      img.loading = 'lazy';
      media.appendChild(img);
    }
    a.appendChild(media);

    var body = document.createElement('span');
    body.className = 'wishlist__body';
    var t = document.createElement('span');
    t.className = 'wishlist__title';
    t.textContent = item.t;
    body.appendChild(t);
    var price = money(item);
    if (price) {
      var p = document.createElement('span');
      p.className = 'wishlist__price';
      p.textContent = price;
      body.appendChild(p);
    }
    var cta = document.createElement('span');
    cta.className = 'wishlist__cta';
    cta.textContent = strings.view || 'View artwork';
    body.appendChild(cta);
    a.appendChild(body);
    li.appendChild(a);

    var rm = document.createElement('button');
    rm.type = 'button';
    rm.className = 'wishlist__remove';
    rm.setAttribute('data-wishlist-remove', item.h);
    rm.setAttribute('aria-label', (strings.remove || 'Remove from wishlist') + ' — ' + item.t);
    rm.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" '
      + 'stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    li.appendChild(rm);

    return li;
  }

  function render() {
    var W = window.AirXWishlist;
    var list = W ? W.list() : [];
    root.textContent = '';

    if (!list.length) {
      root.hidden = true;
      if (emptyEl) emptyEl.hidden = false;
      if (summaryEl) summaryEl.hidden = true;
      return;
    }

    root.hidden = false;
    if (emptyEl) emptyEl.hidden = true;
    for (var i = 0; i < list.length; i++) root.appendChild(card(list[i]));

    if (summaryEl) {
      var tpl = list.length === 1
        ? (strings.countOne || '1 artwork saved')
        : (strings.countOther || '[n] artworks saved');
      summaryEl.textContent = tpl.replace('[n]', String(list.length));
      summaryEl.hidden = false;
    }
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wishlist-remove]');
    if (!btn || !window.AirXWishlist) return;
    var handle = btn.getAttribute('data-wishlist-remove');
    var item = window.AirXWishlist.list().find(function (i) { return i.h === handle; });
    window.AirXWishlist.remove(handle);
    if (liveEl && item) {
      liveEl.textContent = (strings.remove || 'Removed') + ' — ' + item.t;
    }
  });

  if (window.AirXWishlist) window.AirXWishlist.on(render);
  else document.addEventListener('airx:wishlist:changed', render);
  render();
})();
